/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormFieldError } from 'uikit/forms';

import FormFieldUploadPreview from './formFieldUploadPreview';
import FormFieldUploadActions from './formFieldUploadActions';

import styles from '../styles/formFieldUpload.module.scss';

const FormFieldUpload = ({
  buttonSize,
  className,
  hasIcon,
  icon,
  iconPosition,
  permittedFormats,
  uploadType,
  uploadButtonText,
  hasReplaceUploadButton,
  replaceUploadButtonText,
  hasRemoveUploadButton,
  removeUploadButtonText,
  upload,
  fieldId,
  handleFileUpload,
  handleRemoveUpload,
  isDisabled,
}) => (
  <div className={classNames(styles.element, className)}>
    <FormFieldUploadPreview
      key="forms__form-field-upload-preview"
      upload={upload}
      uploadType={uploadType}
    />
    <FormFieldUploadActions
      buttonSize={buttonSize}
      hasIcon={hasIcon}
      icon={icon}
      iconPosition={iconPosition}
      permittedFormats={permittedFormats}
      fieldId={fieldId}
      upload={upload}
      uploadButtonText={uploadButtonText}
      removeUploadButtonText={removeUploadButtonText}
      replaceUploadButtonText={replaceUploadButtonText}
      hasReplaceUploadButton={hasReplaceUploadButton}
      hasRemoveUploadButton={hasRemoveUploadButton}
      handleFileUpload={handleFileUpload}
      handleRemoveUpload={handleRemoveUpload}
      isDisabled={isDisabled}
    />
    <FormFieldError hasError={!!upload.error} isDirty isHidden={false} error={upload.error} />
  </div>
);

FormFieldUpload.defaultProps = {
  buttonSize: 'medium',
  hasIcon: false,
  icon: '',
  iconPosition: 'right',
  replaceUploadButtonText: '',
  permittedFormats: '',
  hasRemoveUploadButton: false,
  removeUploadButtonText: '',
  handleRemoveUpload: null,
  isDisabled: false,
};

FormFieldUpload.propTypes = {
  buttonSize: PropTypes.string,
  className: PropTypes.string,
  hasIcon: PropTypes.bool,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  uploadType: PropTypes.string,
  permittedFormats: PropTypes.string,
  uploadButtonText: PropTypes.string.isRequired,
  hasReplaceUploadButton: PropTypes.bool.isRequired,
  replaceUploadButtonText: PropTypes.string,
  hasRemoveUploadButton: PropTypes.bool,
  removeUploadButtonText: PropTypes.string,
  upload: PropTypes.shape({
    url: PropTypes.string,
    file: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    status: PropTypes.string,
    progress: PropTypes.number,
    error: PropTypes.string,
  }).isRequired,
  fieldId: PropTypes.string.isRequired,
  handleFileUpload: PropTypes.func.isRequired,
  handleRemoveUpload: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default FormFieldUpload;
